import "lazysizes";

// SCROLL
// -- Init
var scaleratio = $(window).outerHeight() / 1000;
var aniComplete = true;

if ($(".scrollContent").length > 0) {
  let frameSwipe = {
    total: 5,
    frames: [
      ".section--1",
      ".section--2",
      ".section--3",
      ".section--4",
      ".section--footer",
    ],
    navigation: ".nav-top li",
    index: 0,
    isEndAnimate: true,
    animateDelay: 400,
    animateEndDelay: 400,
  };

  $(".scrollLink").on("click", function (e) {
    e.preventDefault();
    if (frameSwipe.isEndAnimate) {
      frameSwipe.isEndAnimate = false;

      $("html").animate(
        {
          scrollTop: $($(this).data("scroll-link")).offset().top,
        },
        600,
        function () {
          frameSwipe.isEndAnimate = true;
        }
      );
    }
  });
}


